// Jam virtual untuk render animatic deterministik: requestAnimationFrame & performance.now dikendalikan
// dari luar (Playwright memanggil window.__animatic.tick(t) per frame). Harus dipasang SEBELUM createEngine.
export function pasangJamVirtual() {
  let now = 0;
  let antrean = [];
  let id = 0;
  window.requestAnimationFrame = cb => { antrean.push(cb); return ++id; };
  window.cancelAnimationFrame = () => {};
  performance.now = () => now;
  return {
    set(tDetik) { now = tDetik * 1000; },
    jalankan() { const q = antrean; antrean = []; for (const cb of q) cb(now); },
  };
}

export const ease = {
  inOut: x => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2),
  out: x => 1 - Math.pow(1 - x, 3),
  // overshoot kecil ala motion graphic (back-out)
  back: x => 1 + 2.3 * Math.pow(x - 1, 3) + 1.3 * Math.pow(x - 1, 2),
  clamp: (x, a = 0, b = 1) => Math.max(a, Math.min(b, x)),
};
